import { render } from "./FugleTable.vue?vue&type=template&id=936b419c&scoped=true&ts=true"
import script from "./FugleTable.vue?vue&type=script&lang=ts"
export * from "./FugleTable.vue?vue&type=script&lang=ts"

import "./FugleTable.vue?vue&type=style&index=0&id=936b419c&lang=scss&scoped=true"
import "./FugleTable.vue?vue&type=style&index=1&id=936b419c&scoped=true&lang=css"
import "./FugleTable.vue?vue&type=style&index=2&id=936b419c&scoped=true&lang=css"

import exportComponent from "../../../../../../../ldplatform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-936b419c"]])

export default __exports__